import { apiClient } from "../apiClient";

const LOP_TIN_CHI_API = "lop-tin-chi";
export const lopTinChiApi = {
    SelectByKyDangKy: (ky_dang_ky: number) => apiClient.get(`${LOP_TIN_CHI_API}/ky-dang-ky/${ky_dang_ky}`),
}